import { render, staticRenderFns } from "./Backlog.vue?vue&type=template&id=4cb46d4b&scoped=true&"
import script from "./Backlog.vue?vue&type=script&lang=js&"
export * from "./Backlog.vue?vue&type=script&lang=js&"
import style0 from "./Backlog.vue?vue&type=style&index=0&id=4cb46d4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb46d4b",
  null
  
)

export default component.exports